import BLNativeBridge from 'shared_js/plugins/BLNativeBridge';
import SnackbarPlugin from 'shared_js/plugins/snackbar';
import Tracker from 'lib/tracker';
import itemMitraTracker from 'shared_js/modules/tracker/itemMitraTracker';
import getRouter from './router';
import store from './store';
import App from './App';

const APP_ID_SELECTOR = '#item-mitra-app';

window.Vue.use(BLNativeBridge);
window.Vue.use(SnackbarPlugin);

window.Vue.prototype.$tracker = itemMitraTracker(Tracker);

const app = new window.Vue({
  store: new window.Vuex.Store(store),
  components: { App },
  template: '<App />',
  router: getRouter(window.Vue),
});

app.$mount(APP_ID_SELECTOR);
